import React, { useState, useEffect } from "react";
import "../Customer/CustomerList.css";
import { FaEdit } from "react-icons/fa";
import ListHeader from "../Customer/ListHeader/ListHeader";
import Customerlistheader from "../Customer/Customerlistheader";
import Spinner from "../../Component/Spinner/Spinner";
import axios from "axios";
import { Api } from "../../BackendApi/api";
import { useNavigate } from "react-router-dom";
import InfiniteScroll from "react-infinite-scroll-component";
import EditCustomerOverlay from "../Customer/EditCustomerOverlay/EditCustomerOverlay";
import { formatIndianDate } from "../../Component/IndFormatDate/formatIndianDate";
import ConfirmPopup from "../../Component/ConfirmPopup/ConfirmPopup";
import { APP_VERSION } from "../Version Provider/VersionConfig";

const columnToApiMap = {
    customerName: "CustName",
    mobile: "CustMobile",
    coins: "CustCurrentCoins",
    createdBy: "CreatedByAdminName",
    status: "Status",
    companyName: "CompName",
    lastLogin: "LastLogin",
    lastTransaction: "LastTransaction",
    reference: "Reference",
    address: "CustAddress",
    mapLocation: "CustLocation",
    createdAt: "CreatedAt",
};

const CustomerList = () => {
    const navigate = useNavigate();

    const [globalSearch, setGlobalSearch] = useState("");
    const [columnSearch, setColumnSearch] = useState({
        customerName: "",
        mobile: "",
        coins: "",
        createdBy: "",
        status: "active",
        companyName: "",
        lastLoginStartDate: null,
        lastLoginEndDate: null,
        lastTransactionStartDate: null,
        lastTransactionEndDate: null,
        lastLogin: "",
        lastTransaction: "",
        reference: "",
        address: "",
        mapLocation: "",
    });

    const [sortState, setSortState] = useState({
        column: "lastTransaction",
        order: "desc",
    });

    const [data, setData] = useState([]);
    const [page, setPage] = useState(1);
    const [hasMore, setHasMore] = useState(true);
    const [loading, setLoading] = useState(false);
    const [showEditOverlay, setShowEditOverlay] = useState(false);
    const [selectedCustomer, setSelectedCustomer] = useState(null);
    //version control state
    const [versionCode] = useState(APP_VERSION);
    const [popup, setPopup] = useState({
        show: false,
        message: "",
        type: "success",
    });
    const limit = 20;

    const handleSortChange = (column, order) => {
        setSortState({ column, order });
        setData([]);
        setPage(1);
        setHasMore(true);
    };

    const fetchCustomers = async (
        pageNum = 1,
        currentSortState = sortState,
    ) => {
        setLoading(true);
        try {
            const token = localStorage.getItem("authToken");
            if (!token) {
                navigate("/");
                return;
            }

            const startfrom = (pageNum - 1) * limit;
            const apiSortColumn =
                columnToApiMap[currentSortState.column] || "LastTransaction";
            const apiSortOrder = currentSortState.order === "asc" ? 1 : -1;

            const payload = {
                VersionCode: versionCode,

                searchstring: globalSearch || "",
                custName: columnSearch.customerName || "",
                custMobile: columnSearch.mobile || "",
                custCoins: columnSearch.coins || "",
                custStatus:
                    columnSearch.status === "active"
                        ? "ACTIVE"
                        : columnSearch.status === "deactive"
                          ? "DEACTIVE"
                          : "",
                companyName: columnSearch.companyName || "",
                createdBy: columnSearch.createdBy || "",
                reference: columnSearch.reference || "",
                custAddress: columnSearch.address || "",
                custLocation: columnSearch.mapLocation || "",

                lastLoginStartDate: columnSearch.lastLoginStartDate
                    ? new Date(columnSearch.lastLoginStartDate).toISOString()
                    : null,
                lastLoginEndDate: columnSearch.lastLoginEndDate
                    ? new Date(
                          new Date(columnSearch.lastLoginEndDate).setHours(
                              23,
                              59,
                              59,
                              999,
                          ),
                      ).toISOString()
                    : null,
                lastTransactionStartDate: columnSearch.lastTransactionStartDate
                    ? new Date(
                          columnSearch.lastTransactionStartDate,
                      ).toISOString()
                    : null,
                lastTransactionEndDate: columnSearch.lastTransactionEndDate
                    ? new Date(
                          new Date(
                              columnSearch.lastTransactionEndDate,
                          ).setHours(23, 59, 59, 999),
                      ).toISOString()
                    : null,

                startfrom,
                limit,
                SortColumn: apiSortColumn,
                SortOrder: apiSortOrder,
            };

            const response = await axios.post(Api.getCustomers, payload, {
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${token}`,
                },
            });
            if (
                response.data.status === 0 &&
                response.data.message &&
                response.data.message.toLowerCase().includes("version")
            ) {
                setPopup({
                    show: true,
                    message: (
                        <>
                            <span style={{ fontSize: "20px" }}>❌</span>{" "}
                            {response.data.message}
                        </>
                    ),
                    type: "error",
                });
                return;
            }
            const customerArray =
                response.data.data || response.data.customers || [];

            const getLocation = (custLocation) => {
                if (!custLocation) return { lat: 23.0225, lng: 72.5714 };

                if (custLocation.coordinates?.length === 2) {
                    return {
                        lat: custLocation.coordinates[1],
                        lng: custLocation.coordinates[0],
                    };
                }

                if (typeof custLocation === "string") {
                    const parts = custLocation.split(",");
                    if (parts.length === 2) {
                        return { lat: Number(parts[0]), lng: Number(parts[1]) };
                    }
                }

                if (custLocation.lat && custLocation.lng) {
                    return {
                        lat: Number(custLocation.lat),
                        lng: Number(custLocation.lng),
                    };
                }

                return { lat: 23.0225, lng: 72.5714 };
            };

            let customers = customerArray.map((item) => {
                const location = getLocation(item.CustLocation);
                return {
                    id: item._id,
                    customerName: item.CustName || "N/A",
                    mobile: item.CustMobile || "N/A",
                    coins: item.CustCurrentCoins ?? 0,
                    createdBy: item.CreatedByAdminName || "Admin",
                    status: item.Status || "DEACTIVE",
                    companyName: item.CompName || "N/A",
                    lastLogin: item.LastLogin
                        ? formatIndianDate(item.LastLogin)
                        : "-",
                    lastTransaction: item.LastTransaction
                        ? formatIndianDate(item.LastTransaction)
                        : "-",
                    reference: item.Reference || "-",
                    address: item.CustAddress || "-",
                    mapLocation: location,
                };
            });

            customers = customers.map((item, index) => ({
                ...item,
                Sr: startfrom + index + 1,
            }));

            setData((prev) =>
                pageNum === 1 ? customers : [...prev, ...customers],
            );
            if (customers.length < limit) setHasMore(false);
        } catch (err) {
            setPopup({
                show: true,
                message:
                    err.response?.data?.message || "Failed to fetch customers.",
                type: "error",
            });
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        setData([]);
        setPage(1);
        setHasMore(true);
        const handler = setTimeout(() => {
            fetchCustomers(1);
        }, 300);
        return () => clearTimeout(handler);
    }, [globalSearch, columnSearch, sortState]);

    const fetchMoreData = () => {
        const nextPage = page + 1;
        setPage(nextPage);
        fetchCustomers(nextPage, sortState);
    };

    const handleEditClick = (customer) => {
        setSelectedCustomer(customer);
        setShowEditOverlay(true);
    };

    const handleCloseOverlay = () => {
        setShowEditOverlay(false);
        setSelectedCustomer(null);
    };

    const handlePopupClose = () => {
        setPopup({ ...popup, show: false });
    };

    return (
        <div className="table-container">
            <ListHeader
                search={globalSearch}
                setSearch={setGlobalSearch}
                columnSearch={columnSearch}
                setColumnSearch={setColumnSearch}
                onRefresh={() => {
                    setSortState({ column: "lastTransaction", order: "desc" });
                    setData([]);
                    setPage(1);
                    setHasMore(true);
                }}
            />

            <div className="grid-table" id="scrollableDiv">
                <Customerlistheader
                    columnSearch={columnSearch}
                    setColumnSearch={setColumnSearch}
                    currentSortColumn={sortState.column}
                    currentSortOrder={sortState.order}
                    onSortChange={handleSortChange}
                />

                {loading && page === 1 ? (
                    <Spinner />
                ) : data.length > 0 ? (
                    <InfiniteScroll
                        dataLength={data.length}
                        next={fetchMoreData}
                        hasMore={hasMore}
                        loader={<Spinner />}
                        endMessage={
                            <div className="no-data">No more customers</div>
                        }
                        scrollableTarget="scrollableDiv"
                        style={{ overflow: "visible" }}
                    >
                        {data.map((row) => (
                            <div className="grid-row border" key={row.Sr}>
                                <div>{row.Sr}</div>
                                <div className="action-icons">
                                    <button
                                        className="edit"
                                        onClick={() => handleEditClick(row)}
                                    >
                                        <FaEdit />
                                    </button>
                                </div>
                                <div key={row.id} style={{ cursor: "pointer" }}>
                                    {row.customerName}
                                </div>

                                <div>{row.mobile}</div>
                                <div>{row.coins}</div>
                                <div>{row.createdBy}</div>
                                <div>
                                    <span className={`status-badge ${row.status === "ACTIVE" ? "active" : "deactive"}`}>
                                        {row.status === "ACTIVE" ? "Active" : "Deactive"}
                                    </span>
                                </div>
                                <div>{row.companyName}</div>
                                <div>{row.lastLogin}</div>
                                <div>{row.lastTransaction}</div>
                                <div>{row.reference}</div>
                                <div>{row.address}</div>
                                <div className="map-cell">
                                    <button
                                        className="view-map-btn"
                                        onClick={() => {
                                            if (
                                                row.mapLocation?.lat &&
                                                row.mapLocation?.lng
                                            ) {
                                                const { lat, lng } =
                                                    row.mapLocation;
                                                const googleMapUrl = `https://www.google.com/maps?q=${lat},${lng}`;
                                                window.open(
                                                    googleMapUrl,
                                                    "_blank",
                                                );
                                            } else {
                                                alert(
                                                    "Location not available for this customer",
                                                );
                                            }
                                        }}
                                    >
                                        📍View Map
                                    </button>
                                </div>
                            </div>
                        ))}
                    </InfiniteScroll>
                ) : (
                    <div className="no-data">
                        {loading
                            ? "Searching customers..."
                            : "No customers found"}
                    </div>
                )}
            </div>

            {showEditOverlay && selectedCustomer && (
                <EditCustomerOverlay
                    customer={selectedCustomer}
                    onClose={handleCloseOverlay}
                    onSave={() => {
                        handleCloseOverlay();
                        setData([]);
                        setPage(1);
                        setHasMore(true);
                        fetchCustomers(1);
                    }}
                />
            )}

            <ConfirmPopup
                show={popup.show}
                message={popup.message}
                type={popup.type}
                onClose={handlePopupClose}
            />
        </div>
    );
};

export default CustomerList;
